var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-muted text-small"},[_vm._v("Loading...")])
}
var staticRenderFns = []

export { render, staticRenderFns }